import { createAction, getActionList } from './action-utils';
import { HIDE_MODAL_V2, SHOW_MODAL_V2 } from './types';

const actions = {
  showModalV2: (config: any) => createAction(SHOW_MODAL_V2, config),
  hideModalV2: () => createAction(HIDE_MODAL_V2, {}),
};

export default actions;

const actionList = getActionList(actions);

export type ModalV2ActionType = typeof actionList;
